import * as React      from 'react';
import moment          from 'moment-timezone';
import { getTimeZone } from '../../helpers/timeUtils';
import {
    Message,
    MessageDeliveryStatuses
}                      from '../../types';
import Ago             from '../../components/Ago';

interface TimestampSeparatorProps {
    dateAdded: string;
}

interface TimeStampProps {
    message: Message;
}

export const TimestampSeparator: React.StatelessComponent<TimestampSeparatorProps> = ({ dateAdded }) => (
    <div className="messagesFeed__timeStamp">
        <span className="messagesFeed__separator"></span>
        <span className="messagesFeed__separatorTime">{moment.utc(dateAdded).local().tz(getTimeZone()).format('dddd MMMM Do')}</span>
        <span className="messagesFeed__separator"></span>
    </div>
);

export const TimeStamp: React.StatelessComponent<TimeStampProps> = ({ message }) => (
    <div className="messagesFeed__timestamp">
    {
        message.date_added && (message.delivery_status === MessageDeliveryStatuses.SUCCESS) &&
        <Ago time={message.date_added} />
    }
    </div>
);





// WEBPACK FOOTER //
// ./src/sections/Message/Timestamp.tsx